module.exports = __webpack_public_path__ + "9515b298433f8d63df2ec09439991d7b.png";